Postlogin = (function (my) {
    my.StudentDashboard = {};
    const self = my.StudentDashboard;

    self.init = function () {
        animateProgressCircles();
    };

    // The modal renders with aria-hidden+inert on the server so
    // closed-state passes axe. Open/close must toggle BOTH so focus
    // can enter on open and is blocked on close.
    const openBeepModal = (beepModal) => {
        beepModal.addClass('enabled activated')
            .removeAttr('aria-hidden')
            .removeAttr('inert');
    };
    const closeBeepModal = (beepModal) => {
        beepModal.removeClass('enabled activated')
            .attr('aria-hidden', true)
            .attr('inert', '');
    };

    $('.easy-group-add button').on('click keydown', (e) => {
        const beepModal = $('#beep-9-modal');

        const keyPressed = e.keyCode ? e.keyCode : e.which;
        if (keyPressed === '13' || keyPressed === '32' || e.type === 'click') {
            openBeepModal(beepModal);
            $('#easy-group-code').focus();
        }
    });

    $('body.body-student-index').on('keyup', (e) => {
        const beepModal = $('#beep-9-modal');
        const createButton = $('.group-code-button');
        if (Jr.Utils.checkKey(e, 'escape')) {
            closeBeepModal(beepModal);
            createButton.focus();
        }
    });

    $('#join-cancel').on('click', () => {
        closeBeepModal($('#beep-9-modal'));
        $('.group-code-button').focus();
    });

    $('#join-group').on('click', () => {
        const beepModal = $('#beep-9-modal');
        const joinUrl = beepModal.data('join-url');
        const groupCode = $('#easy-group-code').val();

        $.post(joinUrl.replace(':group_code', groupCode), (data) => {
            const notificationOptions = {};
            const hasError = Object.prototype.hasOwnProperty.call(data, 'error');

            if (hasError) {
                notificationOptions.title = 'Error';
                notificationOptions.text = 'Failed to join group. Are you already in it?';
                notificationOptions.icon = 'fa fa-exclamation-triangle';
                notificationOptions.type = 'error';

                VjsUtility.Notification.error(notificationOptions);
            } else {
                notificationOptions.title = 'Success';
                notificationOptions.text = 'Successfully joined group';
                notificationOptions.icon = 'fa-regular fa-circle-check';
                notificationOptions.type = 'success';

                VjsUtility.Notification.success(notificationOptions);
                closeBeepModal(beepModal);
                $('.group-code-button').focus();
            }

            if (!hasError) {
                $('#easy-group-code').val('');
            }
        }).fail(() => {
            VjsUtility.Notification.error('There was an issue');
        });
    });

    const progressCircles = [];

    const animateProgressCircles = function () {
        $('.assignment-progress').each(function () {
            const progress = $(this).attr('data-progress');
            const assignmentId = $(this).attr('data-assignment-id');

            const bar = new ProgressBar.Circle(`#${$(this).attr('id')}`, {
                color: '#eee',
                strokeWidth: 4,
                trailWidth: 3,
                trailColor: 'rgba(255,255,255,0.5)',
                easing: 'easeInOut',
                duration: 1400,
                text: {
                    autoStyleContainer: false,
                },
                from: { color: '#fff', width: 2 },
                to: { color: '#29861c', width: 3 },
                // Set default step function for all animate calls
                step(state, circle) {
                    circle.path.setAttribute('stroke', state.color);
                    circle.path.setAttribute('stroke-width', (circle.value() * 100) / 3);
                    const value = Math.round(circle.value() * 100);
                    if (value === 0) {
                        circle.setText('0%');
                    } else {
                        circle.setText(`${value}%`);
                    }
                },
            });
            bar.animate(progress / 100); // Value from 0.0 to 1.0
            progressCircles[assignmentId] = bar;
        });
    };

    return my;
}(Postlogin || {}));
